const CLICK_SUBMIT_STATUS = 'isSubmit/CLICK_SUBMIT_STATUS';

const initialState = {
    submitStatus: false
};
const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case CLICK_SUBMIT_STATUS:
        return Object.assign({}, state, {
            submitStatus: action.submitStatus
        });
    default:
        return state;
    }
};
const setSubmitStatus = submitStatus => {
    return {
        type: CLICK_SUBMIT_STATUS,
        submitStatus: submitStatus
    };
   
};

export {
    reducer as default,
    initialState as isSubmitInitialState,
    setSubmitStatus
};
